import { render } from "./DashboardGraphComponent.vue?vue&type=template&id=63a0beb2&scoped=true&ts=true"
import script from "./DashboardGraphComponent.vue?vue&type=script&lang=ts"
export * from "./DashboardGraphComponent.vue?vue&type=script&lang=ts"

import "./DashboardGraphComponent.vue?vue&type=style&index=0&id=63a0beb2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a0beb2"]])

export default __exports__